import { render, staticRenderFns } from "./ScreenContentApprover.vue?vue&type=template&id=7a651c52&scoped=true"
import script from "./ScreenContentApprover.vue?vue&type=script&lang=js"
export * from "./ScreenContentApprover.vue?vue&type=script&lang=js"
import style0 from "./ScreenContentApprover.vue?vue&type=style&index=0&id=7a651c52&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a651c52",
  null
  
)

export default component.exports